import { FC } from 'react';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import App from './App';
import Notifier from './components/Notifier';
import { ConfigProvider } from 'antd';
import koKR from 'antd/lib/locale/ko_KR';
import enUS from 'antd/lib/locale/en_US';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    zIndex: 100000,
  },
});

const AppProvider: FC = () => {
  const { i18n } = useTranslation();
  const classes = useStyles();

  return (
    <SnackbarProvider
      classes={{
        containerRoot: classes.root,
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      autoHideDuration={3000}
    >
      <Notifier />
      <ConfigProvider locale={i18n.language === 'ko' ? koKR : enUS}>
        <App />
      </ConfigProvider>
    </SnackbarProvider>
  );
};

export default AppProvider;
